import { Pipe, PipeTransform } from '@angular/core';
import { LimitsPerNbSteps } from '@shared/constants';
import { StepChallenge } from '@shared/factory';

@Pipe({
  standalone: true,
  name: 'progressWidth',
})
export class ProgressWidthPipe implements PipeTransform {
  transform(
    challenge: StepChallenge,
    limitsPerNbSteps: LimitsPerNbSteps
  ): string {
    const progress: number = challenge.progress;
    const targets: Array<number> = challenge.targets;
    if (progress === 0) {
      return `${limitsPerNbSteps.oneStep.start}px`;
    }

    if (targets.length === 1 && progress <= targets[0]) {
      return this.computeProgressInPixel(
        limitsPerNbSteps.oneStep.start,
        limitsPerNbSteps.oneStep.end,
        0,
        challenge
      );
    }

    if (targets.length === 2) {
      if (progress <= targets[0]) {
        return this.computeProgressInPixel(
          limitsPerNbSteps.twoStep.step1.start,
          limitsPerNbSteps.twoStep.step1.end,
          0,
          challenge
        );
      }
      if (progress <= targets[1]) {
        return this.computeProgressInPixel(
          limitsPerNbSteps.twoStep.step2.start,
          limitsPerNbSteps.twoStep.step2.end,
          1,
          challenge
        );
      }
    }

    if (targets.length === 3) {
      if (progress <= targets[0]) {
        return this.computeProgressInPixel(
          limitsPerNbSteps.threeStep.step1.start,
          limitsPerNbSteps.threeStep.step1.end,
          0,
          challenge
        );
      }
      if (progress <= targets[1]) {
        return this.computeProgressInPixel(
          limitsPerNbSteps.threeStep.step2.start,
          limitsPerNbSteps.threeStep.step2.end,
          1,
          challenge
        );
      }
      if (progress <= targets[2]) {
        return this.computeProgressInPixel(
          limitsPerNbSteps.threeStep.step3.start,
          limitsPerNbSteps.threeStep.step3.end,
          2,
          challenge
        );
      }
    }

    return `${limitsPerNbSteps.oneStep.end}px`;
  }

  /**
   * @param startWidth Number of pixels to the end of previous step or origin of progress bar if first step
   * @param widthToNextStepStart Number of pixels to the start of next step
   * @param step Number of the next step to be reached by customer
   *
   * @returns Width of the progress bar in pixels
   */
  private computeProgressInPixel(
    startWidth: number,
    widthToNextStepStart: number,
    step: 0 | 1 | 2,
    challenge: StepChallenge
  ): string {
    const progress: number = challenge.progress;
    const targets: Array<number> = challenge.targets;
    const previousStepTarget: number = step > 0 ? targets[step - 1] : 0;
    const progressInPx: number =
      ((widthToNextStepStart - startWidth) * (progress - previousStepTarget)) /
      (targets[step] - previousStepTarget);

    return `${progressInPx + startWidth}px`;
  }
}
